import React from 'react'
import RadioForm from './RadioForm'
import { MdDelete } from "react-icons/md";

const FormPageFour = ({
    handleResume,
    handleCoverLetter,
    handleNotification,
    pageFourJobDetails,
    singleQuestion,
    handleSingleQuestion,
    multipleQuestionsArray,
    setmultipleQuestionsArray,
    addSingleQuestionToArray,
    uiDisplayquestion,
    setUiDisplayQuestion
}) => {



    const handleAdditionalQuestionDelete = (e, index) => {
        const result = multipleQuestionsArray.filter((v, i) => {
            return i !== index

        })
        setmultipleQuestionsArray(result)


        const resultArray = result.map((v) => {
            return v.singleQuestion
        })
        setUiDisplayQuestion(resultArray)
    }


    return (
        <>
            <div className="container-fluid px-0 px-sm-5">
                <div className='row row-cols-12'>
                    <div className="col-xl-9 col-12 mx-auto">
                        <div className="card shadow-sm border-0 rounded-4 h-100 employerHomePadding py-2">
                            <div className="card-body">

                                <h6 className='fw-semibold'>Questions</h6>

                                <RadioForm
                                    radioText="Do you want the professional to upload the resume ?"
                                    radioTextId={"resume"}
                                    firstRadioTitle="Yes"
                                    secondRadioTitle="No"
                                    firstRadioId="resume1"
                                    secondRadioId="resume2"
                                    firstRadioValue="Y"
                                    secondRadioValue="N"
                                    radiocommonName="resume"
                                    handleRadioButton={handleResume}
                                    responseYorN={pageFourJobDetails.resume}
                                    pageFourRadio={true}
                                />
                                <RadioForm
                                    radioText="Do you want the professional to upload the cover letter  ?"
                                    radioTextId={"coverLetter"}
                                    firstRadioTitle="Yes"
                                    secondRadioTitle="No"
                                    firstRadioId="coverLetter1"
                                    secondRadioId="coverLetter2"
                                    firstRadioValue="Y"
                                    secondRadioValue="N"
                                    radiocommonName="coverLetter"
                                    handleRadioButton={handleCoverLetter}
                                    responseYorN={pageFourJobDetails.coverLetter}
                                    pageFourRadio={true}
                                />

                                <div className="col-12 mt-3">
                                    <h6 className='fw-semibold'>Notifications</h6>

                                    <RadioForm
                                        radioText="Send an email notification for each new application"
                                        radioTextId={"notification"}
                                        firstRadioTitle="Yes"
                                        secondRadioTitle="No"
                                        firstRadioId="notificationYes"
                                        secondRadioId="notificationNo"
                                        firstRadioValue="Y"
                                        secondRadioValue="N"
                                        radiocommonName="notification"
                                        handleRadioButton={handleNotification}
                                        responseYorN={pageFourJobDetails.receive_notification}
                                        pageFourRadio={true}
                                    />
                                </div>

                                <div id='additionalQuestions'>
                                    <h6 className='fw-semibold my-3 '>Additional Questions</h6>
                                    <ol>
                                        {uiDisplayquestion.map((value, index) => {
                                            return (


                                                <React.Fragment key={index}>
                                                    <div key={index} className='d-flex align-items-center justify-content-between'>
                                                        <div className='w-100'>
                                                            <div className="d-flex justify-content-between mb-3">
                                                                <li className='mb-0 w-100'>{value}</li>
                                                                <MdDelete
                                                                    id={`deleteQuestion${index}Button`}
                                                                    className="icon edit-icon fs-4 brand-color"
                                                                    onClick={(e) => handleAdditionalQuestionDelete(e, index)}

                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        })}
                                    </ol>


                                </div>

                                {/* Job Questions */}
                                <div className='employer-job-questions my-1 mb-3'>

                                    <textarea className={pageFourJobDetails.questions.length > 2 ? 'd-none' : 'w-100 rounded mt-3 p-2 form-control'} rows={2} value={singleQuestion} onChange={(e) => handleSingleQuestion(e)} placeholder='Enter additional questions you would like the professionals to answer (example: visa requirements, references, etc.)' name="job_description" id="job_description"></textarea>
                                </div>
                                <button id='addQuestionButton' className="btn btn-outline-dark col-12 fw-semibold" disabled={pageFourJobDetails.questions.length > 2} type='button' onClick={addSingleQuestionToArray}>Add question</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default FormPageFour